import styled from 'styled-components';

import MediaQueries from '../MediaQueries';

const ShowOnMobile = styled.section`
  display: block;
  ${MediaQueries.notMobile} {
    display: none;
  }
`;
// IE11 does not play nice with display initial

export default ShowOnMobile;
